import { useRef } from "react";

import { twJoin } from "tailwind-merge";

import { TextEditor } from "src/base-components/TextEditor/TextEditor";
import { Toolbar } from "src/base-components/TextEditor/Toolbar";
import { HIGHLIGHT_CLASSES } from "src/flowGraph/canvasSearch/CanvasSearchHighlightContext";
import { useHighlightedScrollIntoView } from "src/utils/useHighlightedScrollIntoview";

export const ManualReviewDescriptionEditor: React.FC<{
  dataLoc?: string;
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
  placeholder: string;
  isSearchHighlighted?: boolean;
}> = ({
  dataLoc,
  value,
  onChange,
  disabled,
  placeholder,
  isSearchHighlighted = false,
}) => {
  const toolbarRef = useRef<HTMLUListElement>(null);
  const [outerRef] = useHighlightedScrollIntoView(isSearchHighlighted);

  return (
    <div
      ref={outerRef}
      className={twJoin(
        "flex flex-1 flex-col rounded border border-gray-200 p-3",
        "focus-within:border-indigo-600 focus-within:ring-2 focus-within:ring-indigo-500/25",
        "group",
        disabled && "bg-gray-50",
        !disabled && "bg-white",
        isSearchHighlighted && HIGHLIGHT_CLASSES,
      )}
      data-loc={dataLoc}
    >
      <TextEditor
        placeholder={placeholder}
        readOnly={disabled}
        toolbarRef={toolbarRef}
        value={value}
        keepEmptyLines
        onChange={onChange}
      />
      {!disabled && (
        <div className="flex justify-between gap-x-3 pt-3">
          <Toolbar ref={toolbarRef} exclude={["code"]} />
        </div>
      )}
    </div>
  );
};
